import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/whatsapp_footer_1.png'


const _withScopeId = n => (_pushScopeId("data-v-7004999a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vechile-list page-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "vechile-list-container main-container" }
const _hoisted_4 = { class: "vechile-list_row" }
const _hoisted_5 = { class: "result-listing-full-block" }
const _hoisted_6 = { class: "text-center no-result-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "25",
  width: "25",
  src: _imports_0
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("thank_you_100")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("callback_thank_you_msg_100")), 1),
              _hoisted_7,
              _createElementVNode("p", null, [
                _createElementVNode("span", {
                  innerHTML:  _ctx.$t('no_quotes_manual_quote_title_100', { toll_free_number: _ctx.companyInfo.toll_free_number }) 
                }, null, 8, _hoisted_8),
                _createElementVNode("a", {
                  href: _ctx.companyInfo.whatsapp_url,
                  target: "_blank"
                }, _hoisted_11, 8, _hoisted_9),
                _hoisted_12,
                _createElementVNode("a", {
                  href: _ctx.homePage,
                  class: "a-link goback-homepage"
                }, _toDisplayString(_ctx.$t("go_back_100")), 9, _hoisted_13)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}